import { useEffect } from "react";
import { Form, useForm } from "react-hook-form";
import CustomInput from "../../CustomInput";

import { useState } from "react";
import TagManager from "react-gtm-module";
import {
  car_key,
  vector_vv,
  rental_charges,
  line_arrow,
  material_outline,
  modify_search_icon,
} from "../../../assets/images";
import { useMutation } from "@tanstack/react-query";
import { trackEvent } from "../../../services/events";
import ReactPixel from "react-facebook-pixel";
import {
  NonInsuranceHolderPickupLocation,
  NonInsuranceHolderRecollectionLocation,
} from "../../../types";
import axiosInstance from "../../../services/axios.instance";
import { API_URL } from "../../../services/apiConfig";
import "./styles.css";
import TimePicker from "../../../components/TimePicker/components/TimePicker";

import { Link, useLocation, useNavigate } from "react-router-dom";
import DateTimeComponent from "../../DateTimeComponent";
import { RentalSummary } from "../..";

const NonInsuranceHolder = () => {
  const formatDate = (dateString: string | undefined) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const { control, setValue, getValues } = useForm({ mode: "onChange" });

  // const [country, setCountry] = useState("");
  // const [selectedOption, setSelectedOption] = useState<string>("");
  // const handleRadioChange = (value: string) => {
  //   setSelectedOption(value);
  // };

  const formData = getValues();
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (!location.state) {
      navigate("/customer/myaccount", { replace: true });
      return;
    }
  }, [location.state, navigate]);

  // Safely access location.state after validation
  const locationState = location.state || {};
  const { selectedItem, merchantId, searchData } = locationState;
  // console.log(searchData, "jbjkfhvjksd--->");

  useEffect(() => {
    if (searchData) {
      try {
        sessionStorage.setItem(
          "customerDashboardSearchData",
          JSON.stringify(searchData),
        );
      } catch (error) {
        console.error("Failed to store search data in sessionStorage", error);
      }
    }
  }, [searchData]);

  useEffect(() => {
    if (location.state?.searchData) {
      setValue("pickUpLocation", location.state.searchData.pickupPlace);
      setValue("returnLocation", location.state.searchData.returnPlace);
    }
  }, [location.state, setValue]);

  useEffect(() => {
    const trackPageLoad = async () => {
      if (!(window as any).fbq && process.env.REACT_APP_META_PIXEL_ID) {
        ReactPixel.init(process.env.REACT_APP_META_PIXEL_ID);
      }
      ReactPixel.track("ViewContent", {
        content_type: "page",
        content_name: "Book Now Screen",
        content_category: "RentACarBook",
      });
      await trackEvent({
        event_name: {
          web: "Kirkos_RentACar_BookNowScreen",
          app: "Kirkos_RentACar_BookNowScreen_App",
        },
        event_category: "RentACarBook_Info",
        module: "BookNow",
        payload: {},
      });
    };
    trackPageLoad();
  }, []);

  const [pickupDate, setPickupDate] = useState<string>("");
  const [dropOffDate, setDropOffDate] = useState<string>("");
  // const [selectedTime, setSelectedTime] = useState("");

  // const [selectedDropTime, setSelectedDropTime] = useState("");

  const handleDeliveryPickup = useMutation({
    mutationFn: (userData: NonInsuranceHolderPickupLocation) =>
      axiosInstance.post(API_URL.DELIVERY_ADDRESS, userData),

    onSuccess: async (successResponse) => {
      if (!(window as any).fbq && process.env.REACT_APP_META_PIXEL_ID) {
        ReactPixel.init(process.env.REACT_APP_META_PIXEL_ID);
      }
      ReactPixel.track("InitiateCheckout", {
        content_type: "delivery_confirmation",
        content_name: "Confirm Delivery Location",
        content_category: "RentACarBook",
      });
      await trackEvent({
        event_name: {
          web: "Kirkos_RentACar_ConfirmButton_Success",
          app: "Kirkos_RentACar_ConfirmButton_Success_App",
        },
        event_category: "RentACarBook_Info",
        module: "BookNow",
        payload: {
          status: "success",
          message: successResponse?.data?.message ?? "",
        },
      });
      // console.log("handle booking success", successResponse);
    },

    onError: (error) => {
      console.log("there was an error", error);
    },
  });
  const handleDeliveryReturn = useMutation({
    mutationFn: (userData: NonInsuranceHolderRecollectionLocation) =>
      axiosInstance.post(API_URL.DELIVERY_ADDRESS, userData),

    onSuccess: (successResponse) => {
      console.log("handleDelivery2 success");
    },

    onError: (error) => {
      console.log("handleDelivery2 error", error);
    },
  });

  // const fileInputRef = useRef<HTMLInputElement>(null);

  // const openFileInput = () => {
  //   fileInputRef?.current?.click();
  // };

  const handlePickupDateChange = (date: string) => {
    setPickupDate(date);
  };

  const handleDropOffDateChange = (date: string) => {
    setDropOffDate(date);
  };

  const handleDropOffTimeChange = () => {
    // setSelectedDropTime(newTime);
  };

  const handleTimeChange = () => {
    // setSelectedTime(time);
  };
  const [daysDifference, setDaysDifference] = useState(0);

  useEffect(() => {
    if (
      searchData &&
      searchData.pickupDate &&
      searchData.dropOffDate &&
      searchData.selectedTime &&
      searchData.selectedDropTime
    ) {
      try {
        const pickupDateTime = new Date(searchData.pickupDate);
        const dropDateTime = new Date(searchData.dropOffDate);

        if (isNaN(pickupDateTime.getTime()) || isNaN(dropDateTime.getTime())) return;

        const [pickupHours, pickupMinutes] = searchData.selectedTime.split(":");
        const [dropHours, dropMinutes] = searchData.selectedDropTime.split(":");

        pickupDateTime.setHours(parseInt(pickupHours), parseInt(pickupMinutes));
        dropDateTime.setHours(parseInt(dropHours), parseInt(dropMinutes));

        const timeDifference = dropDateTime.getTime() - pickupDateTime.getTime();
        const hoursDifference = timeDifference / (1000 * 3600);
        const calculatedDaysDifference = Math.ceil(hoursDifference / 24);

        setDaysDifference(calculatedDaysDifference);
      } catch (e) {
        console.error("Error calculating days difference:", e);
      }
    }
  }, [searchData]);

  // const calculateTotalAmount = (
  //   daysDifference: number,
  //   selectedItem: {
  //     product_details_car: { price_per_day: number; price_per_week: number };
  //   }
  // ) => {
  //   if (daysDifference % 7 !== 0) {
  //     return daysDifference * selectedItem.product_details_car.price_per_day;
  //   } else {
  //     return (
  //       (selectedItem.product_details_car.price_per_week / 7) * daysDifference
  //     );
  //   }
  // };
  const calculateTotalAmount = (
    daysDifference: number,
    selectedItem: {
      product_details_car: {
        price_per_day: number;
        price_per_week: number;
        price_per_month: number;
      };
    },
  ) => {
    if (!selectedItem?.product_details_car) return 0;
    const car = selectedItem.product_details_car;

    const months = Math.floor(daysDifference / 30);
    const remainingAfterMonths = daysDifference % 30;
    const weeks = Math.floor(remainingAfterMonths / 7);
    const remainingDays = remainingAfterMonths % 7;

    return (
      months * car.price_per_month +
      weeks * car.price_per_week +
      remainingDays * car.price_per_day
    );
  };

  const calculateFeeAmounts = (
    daysDifference: number,
    selectedItem: {
      product_details_car: {
        price_per_day_vat?: number;
        price_per_week_vat?: number;
        price_per_month_vat?: number;
        price_per_day_stripeFeeFinal?: number;
        price_per_week_stripeFeeFinal?: number;
        price_per_month_stripeFeeFinal?: number;
      };
    },
  ) => {
    if (!selectedItem?.product_details_car)
      return { totalVat: 0, totalStripeFeeFinal: 0 };

    const car = selectedItem.product_details_car;
    const months = Math.floor(daysDifference / 30);
    const remainingAfterMonths = daysDifference % 30;
    const weeks = Math.floor(remainingAfterMonths / 7);
    const remainingDays = remainingAfterMonths % 7;

    const totalVat =
      months * (car.price_per_month_vat ?? 0) +
      weeks * (car.price_per_week_vat ?? 0) +
      remainingDays * (car.price_per_day_vat ?? 0);

    const totalStripeFeeFinal =
      months * (car.price_per_month_stripeFeeFinal ?? 0) +
      weeks * (car.price_per_week_stripeFeeFinal ?? 0) +
      remainingDays * (car.price_per_day_stripeFeeFinal ?? 0);

    return { totalVat, totalStripeFeeFinal };
  };
  // if (daysDifference % 30 === 0) {
  //   return (
  //     (selectedItem.product_details_car.price_per_month / 30) * daysDifference
  //   );
  // } else if (daysDifference % 7 === 0) {
  //   return (
  //     (selectedItem.product_details_car.price_per_week / 7) * daysDifference
  //   );
  // } else {
  //   return daysDifference * selectedItem.product_details_car.price_per_day;
  // }

  const onFormSubmit = async () => {
    if (!selectedItem || !merchantId || !searchData) {
      navigate("/customer/myaccount", { replace: true });
      return;
    }
    // let { pickUpLocation: pickupAddress }: FieldValues = getValues();
    // let { returnLocation: recollectionAddress }: FieldValues = getValues();

    const userPickupLocation: NonInsuranceHolderPickupLocation = {
      addressType: searchData?.pickupPlace,
      type: "PICKUP_LOCATION",
      firstName: "",
      lastName: "",
      address: "",
      street: "",
      city: "",
      district: "",
      state: "",
      country: "",
      pinCode: "",
      mobileNumber: "",
      latitude: selectedItem?.merchant_latitude,
      longitude: selectedItem?.merchant_longitude,
      landMark: "",
      email: "",
    };

    const userRecollectionLocation: NonInsuranceHolderRecollectionLocation = {
      addressType: searchData?.returnPlace,
      type: "RECOLLECTION_LOCATION",
      firstName: "",
      lastName: "",
      address: "",
      street: "",
      city: "",
      district: "",
      state: "",
      country: "",
      pinCode: "",
      mobileNumber: "",
      latitude: selectedItem?.merchant_latitude,
      longitude: selectedItem?.merchant_longitude,
      landMark: "",
      email: "",
    };

    handleDeliveryPickup.mutate(userPickupLocation);
    handleDeliveryReturn.mutate(userRecollectionLocation);

    if (!(window as any).fbq && process.env.REACT_APP_META_PIXEL_ID) {
      ReactPixel.init(process.env.REACT_APP_META_PIXEL_ID);
    }
    ReactPixel.track("InitiateCheckout", {
      content_type: "booking_confirm",
      content_name: "Confirm Car Booking",
      content_category: "RentACarBook",
      pickup_date: searchData?.pickupDate,
      dropOff_date: searchData?.dropOffDate,
    });
    TagManager.dataLayer({
      dataLayer: {
        event: "begin_checkout",
        page_type: "standard",
        page_path: window.location.pathname,
        page_url: window.location.href,
        product_id: selectedItem?.product_id,
        product_name: selectedItem?.product_name,
        car_brand: selectedItem?.product_details_car?.car_brand,
        price_per_day: selectedItem?.product_details_car?.price_per_day,
        currency: "AED",
        pickup_location: searchData?.pickupPlace,
        dropoff_location: searchData?.returnPlace,
        pickup_datetime: searchData?.pickupDate,
        dropoff_datetime: searchData?.dropOffDate,
      }
    });
    await trackEvent({
      event_name: {
        web: "Kirkos_RentACar_ConfirmButton",
        app: "Kirkos_RentACar_ConfirmButton_App",
      },
      event_category: "RentACarBook_Info",
      module: "BookNow",
      payload: {
        pickup_date: searchData?.pickupDate,
        dropOff_date: searchData?.dropOffDate,
      },
    });

    const pickupDateDiff = new Date(searchData?.pickupDate);
    const dropDateDiff = new Date(searchData?.dropOffDate);

    const [pickupHours, pickupMinutes] = (
      searchData?.selectedTime || "00:00"
    ).split(":");
    const [dropHours, dropMinutes] = (
      searchData?.selectedDropTime || "00:00"
    ).split(":");

    pickupDateDiff.setHours(parseInt(pickupHours), parseInt(pickupMinutes));
    dropDateDiff.setHours(parseInt(dropHours), parseInt(dropMinutes));

    const timeDifference = dropDateDiff.getTime() - pickupDateDiff.getTime();

    const hoursDifference = timeDifference / (1000 * 3600);

    const daysDifference = Math.ceil(hoursDifference / 24);

    const totalAmount = calculateTotalAmount(daysDifference, selectedItem);
    const { totalVat, totalStripeFeeFinal } = calculateFeeAmounts(daysDifference, selectedItem);
    const pickupTime = searchData?.selectedTime || "00:00";
    const dropOffTime = searchData?.selectedDropTime || "00:00";

    const pickupDateTime =
      new Date(searchData?.pickupDate).toISOString().split("T")[0] +
      "T" +
      pickupTime;
    const dropDateTime =
      new Date(searchData?.dropOffDate).toISOString().split("T")[0] +
      "T" +
      dropOffTime;

    const deliveryDetails = {
      formData,
      pickupDateTime,
      dropDateTime,
      daysDifference,
      totalAmount,
      pickupDateDiff,
      dropDateDiff,
      pickupTime,
      dropOffTime,
    };

    const enrichedSelectedItem = {
      ...selectedItem,
      product_details_car: {
        ...selectedItem.product_details_car,
        totalVat,
        totalStripeFeeFinal,
      },
    };

    navigate("/customer/unified-booking", {
      state: { deliveryDetails, selectedItem: enrichedSelectedItem, merchantId, searchData },
    });
  };

  if (!location.state || !selectedItem || !merchantId || !searchData) {
    return null;
  }

  return (
    <Form onSubmit={onFormSubmit} control={control}>
      <div className="row non-insurance-container g-4">
        <div className="col-lg-8 non-insurance-form-section">
          <div className="card card-custom">
            <div className="card-body">
              {/* Header Section */}
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div className="d-flex align-items-center gap-3">
                  <img src={car_key} alt="Delivery" className="header-icon" />
                  <h1 className="page-head-add mb-0">Delivery & Recollection Details</h1>
                </div>
                <Link to="/customer/myaccount" state={{ searchData }} className="modify-search-link">
                  <img src={modify_search_icon} alt="" width="16" />
                  Modify Search
                </Link>
              </div>

              {/* Delivery Section */}
              <div className="mb-5">
                <div className="d-flex align-items-center gap-2 mb-3">
                  <div style={{ width: '4px', height: '20px', background: 'var(--border-color-theme-5)', borderRadius: '2px' }}></div>
                  <h2 className="label_noninsurance mb-0">Pickup Information</h2>
                </div>
                <div className="info-section">
                  <div className="div-location-time-input">
                    <label className="label_noninsurance">Location</label>
                    <div className="non-insur-input-display location">
                      {searchData?.pickupPlace || "N/A"}
                    </div>
                  </div>
                  <div className="div-location-time-input">
                    <label className="label_noninsurance">Date</label>
                    <div className="non-insur-input-display date">
                      {formatDate(searchData?.pickupDate)}
                    </div>
                  </div>
                  <div className="div-location-time-input">
                    <label className="label_noninsurance">Time</label>
                    <div className="non-insur-input-display time">
                      {searchData?.selectedTime}
                    </div>
                  </div>
                </div>
              </div>

              {/* Return Section */}
              <div className="mb-5">
                <div className="d-flex align-items-center gap-2 mb-3">
                  <div style={{ width: '4px', height: '20px', background: 'var(--border-color-theme-5)', borderRadius: '2px' }}></div>
                  <h2 className="label_noninsurance mb-0">Recollection Information</h2>
                </div>
                <div className="info-section">
                  <div className="div-location-time-input">
                    <label className="label_noninsurance">Location</label>
                    <div className="non-insur-input-display location">
                      {searchData?.returnPlace || "N/A"}
                    </div>
                  </div>
                  <div className="div-location-time-input">
                    <label className="label_noninsurance">Date</label>
                    <div className="non-insur-input-display date">
                      {formatDate(searchData?.dropOffDate)}
                    </div>
                  </div>
                  <div className="div-location-time-input">
                    <label className="label_noninsurance">Time</label>
                    <div className="non-insur-input-display time">
                      {searchData?.selectedDropTime}
                    </div>
                  </div>
                </div>
              </div>

              {/* Rental Charges & Deposit */}
              <div className="rental-charges-header">
                <img src={rental_charges} alt="" className="header-icon" />
                <h2 className="page-head-add mb-0">Rental Charges</h2>
                <img src={line_arrow} alt="" className="d-none d-xl-block" style={{ height: '2px', opacity: 0.3 }} />
              </div>

              <div className="deposit-banner">
                <img src={material_outline} alt="" className="header-icon" />
                <div className="deposit-banner-text">
                  Renter is required to make a security deposit of
                  <span className="deposit-amount"> AED {selectedItem.product_details_car.deposit.toFixed(2)} </span>
                  before vehicle collection. This is fully refundable upon safe return.
                </div>
              </div>

              {/* Pricing Grid */}
              <div className="pricing-grid">
                {/* Daily Rate */}
                <div className="price-card">
                  <div className="price-tier">Daily Rate</div>
                  <div className="price-amount">
                    AED {selectedItem.product_details_car.price_per_day.toFixed(2)}
                  </div>
                  <div className="price-details">
                    Booked for <span className="booked-days-highlight">{daysDifference} Days</span>
                    <br />
                    Subtotal: AED {(daysDifference * selectedItem.product_details_car.price_per_day).toFixed(2)}
                  </div>
                  <div className="price-offer-text">Total shown in summary</div>
                </div>

                {/* Weekly Rate */}
                <div className="price-card">
                  <div className="price-tier">Weekly Rate</div>
                  <div className="price-amount">
                    AED {selectedItem.product_details_car.price_per_week.toFixed(2)}
                  </div>
                  <div className="price-details">
                    <span className="old-price">AED {(selectedItem.product_details_car.price_per_day * 7).toFixed(2)}</span>
                    <br />
                    Book for 7, 14, 21+ days to automatically apply this offer.
                  </div>
                </div>

                {/* Monthly Rate */}
                <div className="price-card">
                  <div className="price-tier">Monthly Rate</div>
                  <div className="price-amount">
                    AED {selectedItem.product_details_car.price_per_month.toFixed(2)}
                  </div>
                  <div className="price-details">
                    <span className="old-price">AED {(selectedItem.product_details_car.price_per_day * 30).toFixed(2)}</span>
                    <br />
                    Book for 30+ days for maximum savings.
                  </div>
                </div>
              </div>

              {/* Actions */}
              <div className="non-insurance-actions d-none d-md-flex">
                <Link to="/customer/myaccount" state={{ searchData }} className="modify-search-link">
                  Modify Search
                </Link>
                <button type="submit" className="non_insur_continue_button">
                  CONFIRM BOOKING
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Sidebar Summary */}
        <div className="col-lg-4 non-insurance-summary-section pb-5 mb-3">
          <div className="sticky-sidebar">
            <RentalSummary
              daysDifference={daysDifference}
              totalAmount={calculateTotalAmount(daysDifference, selectedItem)}
              carImage={selectedItem?.product_details?.images?.[0]}
              carModel={selectedItem?.product_details_car?.car_model}
              seat={selectedItem?.product_details_car?.number_of_seats}
              fuelType={selectedItem?.product_details_car?.fuel_type}
            />
          </div>
        </div>

        {/* Mobile Sticky Button */}
        <div className="non-insurance-button-mobile d-md-none">
          <button type="submit" className="non_insur_continue_button w-100">
            CONFIRM BOOKING
          </button>
        </div>
      </div>
    </Form>
  );
};

export default NonInsuranceHolder;
